// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestReopenPreviewGetBody = {
  poolId: string;
  contestId: string;
};

export type typeContestReopenPreviewGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    contestId: string;
    roundId: string;
    roundNumber: number;
    refusalReason:
      "laterRoundOpened" | "resultSignedOff" | "entryRevivedFromRound";
    detectedAt: string;
    previewResultsDigest: string;
    digestMatchesDetection: boolean;
    didOutcomeMove: boolean;
    movedFacets: string[];
    affectedEntries: {
      entryId: string;
      userId: string;
      displayName: string;
      currentStatus: "in" | "eliminated" | "revived";
      proposedStatus: "in" | "eliminated" | "revived";
      currentLivesRemaining: number;
      proposedLivesRemaining: number;
      currentPointsTotal: number;
      proposedPointsTotal: number;
    }[];
    currentStandings: { entryId: string; rank: number; pointsTotal: number }[];
    proposedStandings: { entryId: string; rank: number; pointsTotal: number }[];
    currentWinnerEntryIds: string[];
    proposedWinnerEntryIds: string[];
    currentMedalHolderCount: number;
    proposedMedalHolderCount: number;
    seasonTrophy: {
      applies: boolean;
      state: "resolved" | "awaitingCommissionerPick" | "notApplicable";
      tiebreaker: "splitMedal" | "noWinner" | "commissionerPick";
      currentHolderUserIds: string[];
      proposedHolderUserIds: string[];
      memberPointTotals: {
        userId: string;
        displayName: string;
        pointsTotal: number;
      }[];
    };
  };
};

export type typeContestReopenPreviewGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestReopenPreviewGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestReopenPreviewGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestReopenPreviewGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    contestId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "contestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestReopenPreviewGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestReopenPreviewGetBody);
  }

  return async function postContestReopenPreviewGet(
    payload: typeContestReopenPreviewGetBody,
  ): Promise<
    typeContestReopenPreviewGetOutput200 | typeContestReopenPreviewGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestReopenPreviewGet" failed before calling the network. #a27041b67e5c`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#a27041b67e5c" },
        },
        data: null,
      } as typeContestReopenPreviewGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/reopen-preview-get`,
      httpMethod: "POST",
      options,
    })) as
      | typeContestReopenPreviewGetOutput200
      | typeContestReopenPreviewGetOutput400;
  };
}
